/**
 * DevelopmentIcon
 * 
 * @Author: Focci
 * @Date: 2024-03-07 17:25:54
 * @Last Modified by: Focci
 * @Last Modified time: 2024-03-07 17:25:54
 */

// import PropTypes from 'prop-types'
import Image from 'next/image'
import Scrollbar from '@comp/Scrollbar'
import { useCallback } from 'react'
import { isFunction } from 'lodash-es'
import { ButtonBase } from '@comp/material'
import { useMenuOptions } from '../location/location-map-bar/lib'

function DevelopmentIcon({
  data,
  onClick
}) {
  const handleClick = useCallback(() => {
    isFunction(onClick) && onClick(data.value)
  }, [onClick, data])

  return data && (
    <div className="shrink-0 flex flex-col items-center">
      <ButtonBase className="rounded-md" onClick={handleClick}>
        <div className="w-[5.5rem] h-[3.5rem] md:w-[7.3rem] md:h-[5rem] relative">
          <Image
            src={data.icon || ''}
            alt={data.label}
            width={150}
            height={100}
            loading="lazy"
            className="object-cover"
            unoptimized
          />
        </div>
      </ButtonBase>
      <span className="mt-2">
        {data.label}
      </span>
    </div>
  )
}

export function DevelopmentIcons({
  location, 
  onClick
}) {
  const { devMenus } = useMenuOptions({ location })
  
  return (
    <div className="min-h-[131px]">
      <Scrollbar autoHeight>
        <div className="flex gap-x-3 md:gap-x-4">
          {devMenus.map((item) => (
            <DevelopmentIcon
              key={item.value}
              data={item}
              onClick={onClick}
            />
          ))}
        </div>
      </Scrollbar>
    </div>
  )
}

// DevelopmentIcon.propTypes = {
//   className: PropTypes.string,
// }
